import React from 'react';

const PhoneHoursNumbersList = (props) => {
  return (
    <ul className="phonehours__numbers__list">
      {props.Numbers &&
        props.Numbers.map((number, index) => (
          <li key={index} className="phonehours__numbers__list__item">
            {props.Linkable && number.International ? (
              <a
                className="phonehours__numbers__list__item__link"
                href={number.International && props.IsEmail ? `sip:${number.International}` : `tel:${number.International}`}
              >
                {number.National}
              </a>
            ) : (
              <span className="phonehours__numbers__list__item__link phonehours__numbers__list__item__link--no-link">
                {number.National}
              </span>
            )}
          </li>
        ))}
    </ul>
  );
};

export default PhoneHoursNumbersList;
